<template>
  <DialogLayout
    title="詳細情報"
    :visible.sync="dialogVisible"
    width="47em"
    @open="open"
  >
    <template #form>
      <HangarUsagesDataForm
        ref="hangarUsagesDataForm"
        v-model="hangarUsagesDataFormModel"
        label-width="10em"
        formMode="edit"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
        :autocomplete-registration_symbol-set="autocompleteRegistrationSymbolSet"
      />
    </template>
    <template #footer>
      <!-- <EditDialogFooter
        @update="clickUpdate"
      /> -->
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import HangarUsagesDataForm from '@/components/organisms/dialog/data/HangarUsagesDataForm.vue'
// import EditDialogFooter from '@/components/organisms/dialog/EditDialogFooter.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'
import RegistrationSymbolAutocompleteLoader from '@/mixins/RegistrationSymbolAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    HangarUsagesDataForm
    // EditDialogFooter
  },
  mixins: [
    CustomerAutocompleteLoader,
    RegistrationSymbolAutocompleteLoader
  ],
  props: {
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      hangarUsagesDataFormModel: {
        billing_ym: undefined,
        action_type: undefined,
        operator_code: undefined,
        registration_symbol: undefined,
        hangar_usage_action_time: undefined,
        updated_on: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
    // console.log('RegistrationSymbolMasterRegisterDialog.mounted')
  },
  methods: {
    async clickUpdate () {
      this.$loadingMask.on()

      // const params = { ...this.hangarUsagesDataFormModel }
      // params.user_id = this.$session.get('login-user').userId

      this.$refs.hangarUsagesDataForm.validate()
        .then((valid) => {
          return this.$axios.put('/hangar-usages-data', this.hangarUsagesDataFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          // this.margeCustomerCodeSet(this.hangarUsagesDataFormModel.operator_code)
          // this.margeRegistrationSymbolSet(this.hangarUsagesDataFormModel.registration_symbol)
          this.$emit('refresh')
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['operator_code', 'registration_symbol']
      this.$nextTick(() => {
        this.$refs.hangarUsagesDataForm.clearFields()
        Object.keys(this.hangarUsagesDataFormModel)
          .forEach((x) => {
            if (trimItem.includes(x)) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.hangarUsagesDataFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
